/**
 * DataSafety - public data safety page (/data-safety).
 *
 * v4.36 - 2026-10-29 - EXPO-QUALIFIER-01 (Branko 2026-10-29: "we also need a page for data safety"). Text lives in
 *   the i18n namespace cleanup (safety.*). Public banner without Sign In; linked from /cleanup.
 */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Button, Container, Paper, Typography } from '@mui/material';

const DataSafety: React.FC = () => {
  const { t } = useTranslation('cleanup');
  const sections = t('safety.sections', { returnObjects: true }) as { h: string; p: string }[];
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, md: 6 }, px: 2 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, fontSize: { xs: '1.75rem', md: '2.25rem' } }}>{t('safety.title')}</Typography>
      <Typography sx={{ mt: 2, mb: 3 }}>{t('safety.intro')}</Typography>
      <Paper variant="outlined" sx={{ p: { xs: 2, md: 4 }, borderRadius: 3 }}>
        {sections.map((x) => (
          <Box key={x.h} sx={{ mb: 2.5 }}>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>{x.h}</Typography>
            <Typography color="text.secondary">{x.p}</Typography>
          </Box>
        ))}
      </Paper>
      <Button component={RouterLink} to="/cleanup" sx={{ mt: 3 }}>{t('buttons.start')}</Button>
    </Container>
  );
};

export default DataSafety;
